<template>
  <div :id="containerId" :class="mergedClasses">
    <slot></slot>

    <QuestionAlert
      v-if="questionText"
      :id="questionId"
      :text="questionText"
      :question="question"
    />
  </div>
</template>

<script>
export default {
  name: 'EntityContainer',
  props: {
    containerId: {
      type: String,
      required: true
    },
    questionText: {
      type: String,
      default: null
    },
    questionId: {
      type: String,
      default: 'default-question-id'
    },
    question: {
      type: String,
      default: null
    },
    customClasses: {
      type: String,
      default: ''
    }
  },
  computed: {
    mergedClasses() {
      const defaultClasses = 'cabinet_container mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8';
      return `${defaultClasses} ${this.customClasses}`.trim();
    }
  }
}
</script>
